import { render, staticRenderFns } from "./MyGroup.vue?vue&type=template&id=18e7de44&scoped=true"
import script from "./MyGroup.vue?vue&type=script&lang=js"
export * from "./MyGroup.vue?vue&type=script&lang=js"
import style0 from "./MyGroup.vue?vue&type=style&index=0&id=18e7de44&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18e7de44",
  null
  
)

export default component.exports